// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f1cf8aa","455":"2623ecec","553":"90774e8f","756":"7d93e8ff"}[chunkId] + ".chunk.js";
};